import React from "react";

/**
 * NearNow logo.
 * variant: "light" — coral target + WHITE wordmark (for navy / dark surfaces)
 *          "dark"  — coral target + DARK GREY wordmark (for white / light surfaces)
 * size: pixel height of the logo (width auto)
 */
const Logo = ({ variant = "light", size = 44, testId = "nn-logo", style = {} }) => {
  const src = variant === "dark" ? "/nearnow-logo.png" : "/nearnow-logo-light.png";
  return (
    <img
      src={src}
      alt="NearNow"
      data-testid={testId}
      style={{ height: size, width: "auto", display: "block", ...style }}
    />
  );
};

export default Logo;
